import moment from "moment/moment";
import { Button, Link, Tooltip } from "@mui/material";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";

export default function RenewalDate(props: {
  date: Date | null;
  isReplaceable: boolean;
}) {
  if (props.date) {
    // nosemgrep
    if (process.env.SHOW_ASSIGNMENT_TYPE === "true" && !props.isReplaceable) {
      return <>Not Eligible</>;
      // nosemgrep
    } else if (process.env.LAPTOP_RENEWAL_ENABLED === "true") {
      return <>{moment(props.date).format("MMM DD, yyyy")}</>;
    } else {
      return <DeferredButton />;
    }
  } else {
    return <>NA</>;
  }

  function DeferredButton() {
    const tooltip = (
      <p>
        Laptop replacements have been paused until further communication due to
        current business situation {""} <br />
        <Link
          color={"#ffffff"}
          target="_blank"
          rel="noreferrer"
          href="https://central.thoughtworks.net/newsletter?k=3862ccf3-c25b-11ed-8dfa-711d3975bb15&l=en#:~:text=we%20have%20decided%20to%20extend%20the%20deferral%20of%20all%20laptop%20replacements%20through%20Q4%202023."
        >
          Read Here <br />
        </Link>
      </p>
    );
    return (
      <Button
        variant={"outlined"}
        disableRipple
        sx={{
          border: "0px",
          display: "inline-flex",
          fontSize: "14px",
          padding: "8px 16px",
          borderRadius: "5px",
          margin: "0 auto",
          color: "black",
          backgroundColor: "#ffe6e6",
          "&:hover": {
            backgroundColor: "#ffe6e6",
            border: "0px",
          },
          fontWeight: 300,
        }}
      >
        <Tooltip title={tooltip} sx={{ maxHeight: "100px" }}>
          <ErrorOutlineOutlinedIcon
            style={{
              padding: "0px 8px 0px 0px",
              color: "#D32F2F",
              width: "27px",
              height: "27px ",
            }}
          />
        </Tooltip>
        Deferred
      </Button>
    );
  }
}
